import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
  FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTORDERDETAILS_FAIL_ACTION,
  FETCH_CHEMISTORDERVIEW_INIT_ACTION,
  FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
  FETCH_CHEMISTORDERVIEW_FAIL_ACTION,
  EDIT_ITEMDETAILS_INIT_ACTION,
  EDIT_ITEMDETAILS_SUCCESS_ACTION,
  EDIT_ITEMDETAILS_FAIL_ACTION,
  FETCH_ORDERINACTIVE_INIT_ACTION,
  FETCH_ORDERINACTIVE_SUCCESS_ACTION,
  FETCH_ORDERINACTIVE_FAIL_ACTION,
  FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
  FETCH_CHEMISTINPROGRESSORDER_SUCCESS_ACTION,
  FETCH_CHEMISTINPROGRESSORDER_FAIL_ACTION,
  FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
  FETCH_CHEMISTCOMPLETEDORDER_SUCCESS_ACTION,
  FETCH_CHEMISTCOMPLETEDORDER_FAIL_ACTION,
  FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION,
  FETCH_CHEMISTCANCELLEDORDER_SUCCESS_ACTION,
  FETCH_CHEMISTCANCELLEDORDER_FAIL_ACTION,
  FETCH_DELIVERYSTATUS_INIT_ACTION,
  FETCH_DELIVERYSTATUS_SUCCESS_ACTION,
  FETCH_DELIVERYSTATUS_FAIL_ACTION,
  GET_COMPLETEITEMSURGENT_INIT_ACTION,
  GET_COMPLETEITEMSURGENT_SUCCESS_ACTION,
  GET_COMPLETEITEMSURGENT_FAIL_ACTION,
  CREATE_INVOICEURGENT_INIT_ACTION,
  CREATE_INVOICEURGENT_SUCCESS_ACTION,
  CREATE_INVOICEURGENT_FAIL_ACTION,
  FETCH_ORDERSHIPPED_INIT_ACTION,
  FETCH_ORDERSHIPPED_SUCCESS_ACTION,
  FETCH_ORDERSHIPPED_FAIL_ACTION,
  CHANGE_PAYMENTSTATUS_INIT_ACTION,
  CHANGE_PAYMENTSTATUS_SUCCESS_ACTION,
  CHANGE_PAYMENTSTATUS_ERROR_ACTION,
  ORDERPDF_REPORT_INIT_ACTION,
  ORDERPDF_REPORT_SUCCESS_ACTION,
  ORDERPDF_REPORT_FAIL_ACTION,
  SEARCH_CHEMISTORDERVIEW_INIT_ACTION,
  SEARCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
  SEARCH_CHEMISTORDERVIEW_FAIL_ACTION,
  FETCH_URGENTORDERDELIVERED_INIT_ACTION,
  FETCH_URGENTORDERDELIVERED_SUCCESS_ACTION,
  FETCH_URGENTORDERDELIVERED_FAIL_ACTION,
  RETURN_PURCHASE_ORDER_ACTION,
  RETURN_PURCHASE_ORDER_SUCCESS_ACTION,
  RETURN_PURCHASE_ORDER_FAIL_ACTION,
} from "./action";

import { FETCH_PRODUCTRETURNDETAILS_INIT_ACTION } from "../PurchaseReturnsContainer/action";
import { FETCH_EXPIRYRETURNDETAILS_INIT_ACTION } from "../ExpiryReturnsContainer/action";

import { takeLeading } from "redux-saga/effects";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

var history = createBrowserHistory();

function* fetchChemistOrders(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");

  let pageno = !value.value
    ? 1
    : value.value.page === undefined
      ? 1
      : value.value.page;
  let search = !value.value
    ? ""
    : value.value.searchKey === ""
      ? ""
      : value.value.searchKey;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
      ? ""
      : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distributorProfId}&orderTrk=urgent&orderType=purchase&status=created,confirm&payType=${filter}&limit=10&page=${pageno}&search=${search}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTORDERDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchchemistorderview(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.item.item.id;
  const pageno = value.value.page === undefined ? 1 : value.value.page;

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTORDERVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* EditItemDetails(value) {
  console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", value);

  const token = localStorage.getItem("token");

  const distributorProfId = localStorage.getItem("distributorId");
  const payload = value.value || {};
  const items = Array.isArray(payload) ? payload : payload.items || [];
  const status = payload.status || "confirm";

  let itemList = [];
  let orderId = null;
  items.forEach(function (item) {
    orderId = item.orderId.id;
    itemList.push({
      _id: item.id,
      itemCode: item.itemCode.drugCode,
      unitType: item.unitMeasure,
      itemName: item.itemName,
      unitPrice: item.unitPrice,
      unitRate: item.unitRate,
      qntty: item.qntty,
      avlblQntty: item.avlblQntty,
      batchNo: item.batchNo,
      avlble: item.avlble,
      unitType: item.unitType.name,
      orderNo: item.orderNo,
      orderId: item.orderId.id,
      taxAmnt: item.itemCode.taxAmnt,
      unitCost: item.itemCode.unitCost,
    });
  });
  console.log("^^^^^^^^^^11111111111111111", value);

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/distributorConfirm/` + orderId,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ item: itemList, status }),
      },
    );

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_CHEMISTORDERDETAILS_INIT_ACTION });
      yield toast.success("Order accepted", {
        autoClose: 3000,
        transition: Flip,
      });

      yield put({
        type: EDIT_ITEMDETAILS_SUCCESS_ACTION,
        payload: resJSON,
      });

      yield put({
        type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
      });

      yield put(push({
        pathname: "/normal-orders",
        activeTab: "processing"
      }));
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_ITEMDETAILS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchordersInActive(value) {
  let datas = { status: "rejected" };

  const id = value.value.item.id;

  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/` + id,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(datas),
      },
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield toast.success("Order rejected", {
        autoClose: 3000,
        transition: Flip,
      });

      yield put({
        type: FETCH_ORDERINACTIVE_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
      });

      yield put({
        type: FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_ORDERINACTIVE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchChemistinprogressOrders(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  let pageno = !value.value
    ? 1
    : value.value.page === undefined
      ? 1
      : value.value.page;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
      ? ""
      : value.value.filter;
  let search = !value.value
    ? ""
    : value.value.searchKey === ""
      ? ""
      : value.value.searchKey;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distributorProfId}&orderType=purchase&orderTrk=urgent&status=accepted&payType=${filter}&limit=10&page=${pageno}&search=${search}&sort=-updatedAt`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTINPROGRESSORDER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTINPROGRESSORDER_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchChemistCompletedOrders(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  let pageno = !value.value
    ? 1
    : value.value.page === undefined
      ? 1
      : value.value.page;
  let search = !value.value
    ? ""
    : value.value.searchKey === ""
      ? ""
      : value.value.searchKey;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
      ? ""
      : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distributorProfId}&orderTrk=urgent&payType=${filter}&orderType=purchase&status=shipmentReady,delivered&limit=10&page=${pageno}&search=${search}&sort=-updatedAt`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTCOMPLETEDORDER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTCOMPLETEDORDER_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchChemistCancelledOrders(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  let pageno = !value.value
    ? 1
    : value.value.page === undefined
      ? 1
      : value.value.page;
  let search = !value.value
    ? ""
    : value.value.searchKey === ""
      ? ""
      : value.value.searchKey;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
      ? ""
      : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distributorProfId}&orderTrk=urgent&orderType=purchase&payType=${filter}&status=cancelled,rejected&limit=10&page=${pageno}&search=${search}&sort=-updatedAt`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTCANCELLEDORDER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTCANCELLEDORDER_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchDeliveryStatus() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dlryStatus?sort=sortOrder`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_DELIVERYSTATUS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_DELIVERYSTATUS_FAIL_ACTION,
        error: err,
      });
    }
  }
}

//Complete items in the cart retrieval without pagination
function* Totalitemretrieval(value) {
  const token = localStorage.getItem("token");
  let id = value.value.item.id;
  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=` + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_COMPLETEITEMSURGENT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_COMPLETEITEMSURGENT_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* manualInvoice(val) {
  try {
    const token = localStorage.getItem("token");

    const formdata = new FormData();
    formdata.append("attachmentType", 'urgent-orders');
    formdata.append("file", val.value.file, "name");

    const resImg = yield fetch(`${appConfig.ip}/attachments/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formdata,
    });

    if (!resImg.ok) {
      throw resImg;
    } else {
      const resJSON = yield resImg.json();
      const data = {
        orgId: val.value.orgId,
        customerId: val.value.customerId,
        vendorId: val.value.vendorId,
        orderId: val.value.orderId,
        amount: val.value.amount,
        orderNo: val.value.orderNo,
        imgUrl: resJSON.data.documentUrl,
        invType: "chemist",
        orderType: "urgent",
      };
      const res = yield fetch(`${appConfig.ip}/invoice`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });
      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();

        yield put({
          type: CREATE_INVOICEURGENT_SUCCESS_ACTION,
          payload: resJSON,
        });

        yield put({
          type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
        });

        yield toast.success(`Invoice created`, {
          autoClose: 5000,
          transition: Flip,
        });
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: CREATE_INVOICEURGENT_FAIL_ACTION, error: err });
    } else {
    }
    yield toast.error("Technical Issue,invoice not created!", {
      autoClose: 3000,
      transition: Flip,
      // position: "top-center",
    });
  }
}

function* ordersShippedActive(value) {
  let datas = { status: "shipmentReady" };

  const id = value.value.item.id;

  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/` + id,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(datas),
      },
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Order dispatched", {
        autoClose: 3000,
        transition: Flip,
      });
      yield put({
        type: FETCH_ORDERSHIPPED_SUCCESS_ACTION,
        payload: resJSON,
      });

      yield put({
        type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
      });

      yield put({
        type: FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
      });

      // The order is now shipmentReady and belongs in the Completed tab.
      yield put(
        push({
          pathname: "/orders",
          activeTab: "complete",
        }),
      );
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_ORDERSHIPPED_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* UrgentordersDelivered(value) {
  let datas = { status: "delivered" };

  const id = value.value.item.id;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/` + id,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(datas),
      },
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Order delivered", {
        autoClose: 3000,
        transition: Flip,
      });
      yield put({
        type: FETCH_URGENTORDERDELIVERED_SUCCESS_ACTION,
        payload: resJSON,
      });

      yield put({
        type: FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
      });

      yield put({
        type: FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_URGENTORDERDELIVERED_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* changePaymentstatus(value) {
  // console.log(value);
  let datas = {
    invId: value.value.item.invDtls.id,
    invNo: value.value.item.invDtls.invNo,
    orderId: value.value.item.id,
    orderNo: value.value.item.invDtls.orderNo,
    userId: value.value.item.orderFrom.id,
    recptId: value.value.item.orderTo.id,
    paidAmnt: value.value.item.invDtls.amount,
    userMode: "distributor",
    orgId: value.value.item.invDtls.orgId,
    status: "paid",
  };

  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  try {
    const res = yield fetch(`${appConfig.ip}/payment`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield toast.success("Payment Status Updated", {
        autoClose: 3000,
        transition: Flip,
      });
      yield put({
        type: FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield toast.error("Payment Status Update Failed", {
        autoClose: 3000,
        transition: Flip,
      });
    } else {
    }
  }
}

function* pdfOrderFullData(value) {
  console.log("4444444444444444444444", value);
  const token = localStorage.getItem("token");
  const orderId = value.value.item.orderDetail.orderId.id;
  const ordername = value.value.item.orderFrom.fullName;
  const ordermob = value.value.item.orderFrom.mobileNo;
  const orderNo = value.value.item.orderNo;
  const email = value.value.item.chmstDtls.email;
  const address = value.value.item.addr + value.value.item.pincode;
  const pharmacy = value.value.item.orderFrom.orgName;
  const city = value.value.item.city;
  console.log("333333333333333333333333333", orderId);

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=${orderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      const count = resJSON.count;
      console.log("5555555555555555555555555555", resJSON);
      const doc = new jsPDF();
      const tableColumn = [
        "#",
        "Item Code",
        "Item Name",
        "Quantity",
        "Availability",
      ];

      const tableRows = [];
      resJSON.rows.forEach((report, i) => {
        const reportData = [
          i + 1,
          report.itemCode.drugCode,
          report.itemCode.drugName,
          report.avlblQntty,
          // report.avlble,
          report.avlble === true ? "Available" : "Not Available",
        ];

        tableRows.push(reportData);
        console.log("66666666666666666666666", reportData);
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        theme: "grid",
        styles: { halign: "left", fontSize: 8 },
        headStyles: { fillColor: [23, 104, 183], halign: "center" },
        margin: { top: 65 },
      });

      // doc.autoTable(tableColumn,tableRows,{
      //   // startY: 65,
      //   styles: { fillColor: [255, 0, 0], startY: 65, },
      //   margin: { top: 65 },

      doc.setFontSize(10);
      doc.text(`Order No : ${orderNo}`, 11, 13, {
        float: "right",
        marginRight: "200px",
      });
      doc.setFontSize(10);
      doc.text(`Name : ${ordername}`, 11, 19);
      doc.setFontSize(10);
      doc.text(`Pharmacy : ${pharmacy}`, 11, 25);
      doc.setFontSize(10);
      doc.text(`Mobile : ${ordermob}`, 11, 30);
      doc.setFontSize(10);
      doc.text(`Email : ${email}`, 11, 35);
      doc.setFontSize(10);
      doc.text(`Address : ${address}`, 11, 40);
      doc.setFontSize(10);
      doc.text(`City : ${city}`, 11, 45);

      // doc.save(ordername.pdf);
      doc.setFontSize(13);
      doc.text("Item Details", 11, 55);
      doc.setFontSize(12);
      doc.text(`${count} Items`, 11, 60);
      doc.save(`${ordername}- ${orderNo}.pdf`);

      yield put({
        type: ORDERPDF_REPORT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ORDERPDF_REPORT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchChemistitems(value) {
  console.log("#########00000000000000000", value);
  const token = localStorage.getItem("token");
  // const orderId = value.data.item.city;
  // console.log('#########4444444444444',orderId);

  let search = !value.value
    ? ""
    : value.value.searchKey === ""
      ? ""
      : value.value.searchKey;

  let orderId = !value.value
    ? ""
    : value.value.data.item.id === ""
      ? ""
      : value.value.data.item.id;

  console.log("#########333333333333333333", search);
  console.log("#########444444444444444444", orderId);
  // const orderId = value.value.data.item.id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}&search=${search}`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      console.log("########resJSONresJSON#", resJSON);
      yield put({
        type: SEARCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: SEARCH_CHEMISTORDERVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}


function* createReturnOrderSaga(action) {
  let orderdata = action.value.orderdata;
  let itemData = action.value.itemData;
  let orderData = {
    orgType: orderdata.orgType,
    orderTrk: orderdata.orderTrk,
    orderFrom: orderdata.orderFrom,
    orderFromName: orderdata.orderFromName,
    orderTo: orderdata.orderTo,
    orderToName: orderdata.orderToName,
    orderType: orderdata.orderType,
    addr: orderdata.addr,
    city: orderdata.city,
    pincode: orderdata.pincode,
    returnType: orderdata.returnType,
    payType: "payLater",
    status: "created",
    hasCreated: false,
    totalClaimAmount: orderdata.totalClaimAmount,
    taxAmount: orderdata.taxAmount,
    claimAmountWithTax: orderdata.claimAmountWithTax,
    orderDetail: orderdata.orderDetail
  };

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(appConfig.ip + '/purchaseOrder', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(orderData),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      let itemList = [];
      itemData.forEach(function (item) {
        itemList.push({
          orderId: resJSON.id,
          orderNo: resJSON.orderNo,
          itemCode: item.item.id || item.item._id,
          itemName: item.item.drugName || item.item.itemName || item.item.name,
          purchaseDate: item.purchaseDate,
          expiryDate: item.expiryDate,
          mrp: parseFloat(item.mrp) || 0,
          qntty: parseInt(item.quantity, 10),
          price: parseFloat(item.unitPrice) || 0,
          claimAmount: parseFloat(item.claimAmount) || 0,
          batchNo: item.batchNo || '',
          purchaseInvoiceNo: item.purchaseInvoiceNo || '',
          orderStatus: "created",
          taxPercentage: parseFloat(item.taxPercentage) || 0,
          taxAmount: parseFloat(item.taxAmount) || 0,
          claimAmountWithTax: parseFloat(item.claimAmountWithTax) || 0,
          offer: item.offer || '',
          unitPrice: 0,
          unitRate: 0
        });
      });

      const res2 = yield fetch(appConfig.ip + '/orderDetails/bulk', {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({ item: itemList }),
      });

      if (!res2.ok) {
        throw res2;
      } else {
        const resJSON2 = yield res2.json();

        yield toast.success(`${orderdata.returnType === 'return' ? 'Purchase' : 'Expiry'} Return created successfully`, {
          autoClose: 3000,
          transition: Flip,
        });

        yield put({
          type: RETURN_PURCHASE_ORDER_SUCCESS_ACTION,
          payload: resJSON2,
        });

        yield put({
          type:
            orderdata.returnType === "expiryReturn"
              ? FETCH_EXPIRYRETURNDETAILS_INIT_ACTION
              : FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
          value: { page: 1, filter: "", searchquery: "" }
        });
      }
    }
  } catch (err) {
    let errorMsg = "Failed to create return order";
    try {
      const errJSON = yield err.json();
      errorMsg = errJSON.message || errorMsg;
    } catch (e) { }

    yield toast.error(errorMsg, {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({
      type: RETURN_PURCHASE_ORDER_FAIL_ACTION,
      error: err,
    });
  }
}


export function* OrdersActionWatcher() {
  yield takeEvery(FETCH_CHEMISTORDERDETAILS_INIT_ACTION, fetchChemistOrders);
  yield takeEvery(FETCH_CHEMISTORDERVIEW_INIT_ACTION, fetchchemistorderview);
  yield takeEvery(EDIT_ITEMDETAILS_INIT_ACTION, EditItemDetails);
  yield takeEvery(FETCH_ORDERINACTIVE_INIT_ACTION, fetchordersInActive);
  yield takeEvery(
    FETCH_CHEMISTINPROGRESSORDER_INIT_ACTION,
    fetchChemistinprogressOrders,
  );
  yield takeEvery(
    FETCH_CHEMISTCOMPLETEDORDER_INIT_ACTION,
    fetchChemistCompletedOrders,
  );
  yield takeEvery(
    FETCH_CHEMISTCANCELLEDORDER_INIT_ACTION,
    fetchChemistCancelledOrders,
  );
  yield takeEvery(FETCH_DELIVERYSTATUS_INIT_ACTION, fetchDeliveryStatus);
  yield takeEvery(GET_COMPLETEITEMSURGENT_INIT_ACTION, Totalitemretrieval);
  yield takeEvery(CREATE_INVOICEURGENT_INIT_ACTION, manualInvoice);
  yield takeEvery(FETCH_ORDERSHIPPED_INIT_ACTION, ordersShippedActive);
  yield takeEvery(CHANGE_PAYMENTSTATUS_INIT_ACTION, changePaymentstatus);
  yield takeEvery(ORDERPDF_REPORT_INIT_ACTION, pdfOrderFullData);
  yield takeEvery(SEARCH_CHEMISTORDERVIEW_INIT_ACTION, fetchChemistitems);
  yield takeEvery(FETCH_URGENTORDERDELIVERED_INIT_ACTION, UrgentordersDelivered);
  yield takeLeading(RETURN_PURCHASE_ORDER_ACTION, createReturnOrderSaga);
}
